import { render, staticRenderFns } from "./FederationNoticeContent.vue?vue&type=template&id=a6c1c036&scoped=true"
import script from "./FederationNoticeContent.vue?vue&type=script&lang=js"
export * from "./FederationNoticeContent.vue?vue&type=script&lang=js"
import style0 from "./FederationNoticeContent.vue?vue&type=style&index=0&id=a6c1c036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c1c036",
  null
  
)

export default component.exports